module.exports = __webpack_public_path__ + "img/Invasion-GBM_10X_TPCP.60b66948.png";